__turbopack_context__.v({
  "actionButton": "b7XtRG_actionButton",
  "actions": "b7XtRG_actions",
  "closeButton": "b7XtRG_closeButton",
  "content": "b7XtRG_content",
  "description": "b7XtRG_description",
  "heading": "b7XtRG_heading",
  "policyLink": "b7XtRG_policyLink",
  "primary": "b7XtRG_primary",
  "root": "b7XtRG_root",
});
